import { Action, InputType } from '@projectstorm/react-canvas-core';
import { NodeModel } from '@projectstorm/react-diagrams';
import forEach from 'lodash/forEach';

const inputs = ['input', 'textarea'];
export default class CustomDeleteAction extends Action {
  constructor(options = {}, ToastsStore) {
    options = {
      keyCodes: [46, 8],
      ...options,
    };
    super({
      type: InputType.KEY_DOWN,
      fire: event => {
        if (options.keyCodes.indexOf(event.event.keyCode) !== -1) {
          if(inputs.includes(document.activeElement.tagName.toLowerCase())) {
            return;
          }
          const selectedEntities = this.engine.getModel().getSelectedEntities();
          if (selectedEntities.length > 0 && !this.engine.getModel().isLocked() && (!selectedEntities[0].points || selectedEntities.length > 1)) {
            const nodeLength = selectedEntities.filter(s => s instanceof NodeModel).length
            ToastsStore.info(
              (nodeLength > 1 ? `Selected nodes (${nodeLength})` : "This node will be deleted immediately."),
              `Delete canvas node${nodeLength > 1 ? 's' : ''}`,
              {
                withCancel: false,
                confirmText: "Delete",
                confirmAction: () => {
                  forEach(selectedEntities, model => model.remove());
                  this.engine.repaintCanvas();
                },
              }
            )
          } else if(selectedEntities.length > 0 && !this.engine.getModel().isLocked() && selectedEntities[0].points) {
            forEach(selectedEntities, model => model.remove());
            this.engine.repaintCanvas();
          }
        }
      },
    });
  }
}